export default [
  {
    label: 'Internal ID',
    key: 'internalId',
    sortable: true,
    visible: true,
  },
  {
    label: 'Student ID',
    key: 'studentId',
    sortable: true,
    visible: true,
  },
  {
    label: 'First Name',
    key: 'firstName',
    sortable: true,
    visible: true,
  },
  {
    label: 'Middle Name',
    key: 'middleName',
    sortable: true,
    visible: true,
  },
  {
    label: 'Last Name',
    key: 'lastName',
    sortable: true,
    visible: true,
  },
  {
    label: 'School',
    key: 'building',
    sortable: true,
    visible: true,
    formatter(value) {
      return value?.name
    }
  },
  {
    label: 'Monday',
    key: 'Monday',
    visible: false,
  },
  {
    label: 'Tuesday',
    key: 'Tuesday',
    visible: false,
  },
  {
    label: 'Wednesday',
    key: 'Wednesday',
    visible: false,
  },
  {
    label: 'Thursday',
    key: 'Thursday',
    visible: false,
  },
  {
    label: 'Friday',
    key: 'Friday',
    visible: false,
  },
  {
    key: 'Actions',
    visible: true,
  },
]